/* =========================================================
   VUJA DE — Archive Lock (account形に合わせたインラインUI)
   - Archive クリックでフォーム展開
   - 送信前にクライアントでパスワードを検証（SHA-256ハッシュ比較）
     - 不一致：インラインで Incorrect 表示（ページ遷移しない）
     - 一致：sessionStorageに保存して /pages/archive へ遷移
   - /pages/archive ではLocksmith標準フォームに自動入力→自動送信
   - 自動入力中はbodyを非表示にしてチラ見え防止

   ※ パスワードを変更する場合は EXPECTED_HASH を更新してください
   ※ 計算方法（ターミナル）: echo -n "新しいパスワード" | shasum -a 256
   ========================================================= */

(function () {
  var STORAGE_KEY = '_vd_archive_pending_pw';
  // SHA-256 of "vd8753"
  var EXPECTED_HASH = '91681a790afb15348df5538094991ab9741c37f720416a89bbce45d3466f96a2';

  initInlineForm();

  if (window.location.pathname.match(/^\/pages\/archive\/?$/)) {
    autoSubmitLocksmithIfPending();
  }

  function initInlineForm() {
    var trigger = document.querySelector('.nav-item--archive [data-archive-trigger]');
    var wrap    = document.querySelector('.nav-item--archive .archive-lock-form');
    var form    = document.querySelector('.nav-item--archive [data-archive-form]');
    var input   = form && form.querySelector('input[type="password"]');
    var err     = document.querySelector('.nav-item--archive .archive-lock-error');
    if (!trigger || !wrap || !form || !input) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (wrap.hasAttribute('hidden')) {
        wrap.removeAttribute('hidden');
        input.focus();
        trigger.classList.add('is-open');
      } else {
        wrap.setAttribute('hidden', '');
        trigger.classList.remove('is-open');
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) err.setAttribute('hidden', '');
      var pw = input.value.trim();
      if (!pw) return;

      sha256Hex(pw).then(function (hash) {
        if (hash !== EXPECTED_HASH) {
          // 不一致 → インラインでエラー表示、遷移しない
          if (err) err.removeAttribute('hidden');
          input.select();
          return;
        }
        // 一致 → sessionStorageに保存して遷移
        try { sessionStorage.setItem(STORAGE_KEY, pw); } catch (ex) {}
        window.location.href = '/pages/archive';
      }).catch(function () {
        // crypto.subtle が使えない等の例外時はフォールバックでサーバー任せ
        try { sessionStorage.setItem(STORAGE_KEY, pw); } catch (ex) {}
        window.location.href = '/pages/archive';
      });
    });
  }

  function sha256Hex(text) {
    if (!window.crypto || !window.crypto.subtle) {
      return Promise.reject(new Error('crypto.subtle not available'));
    }
    var bytes = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', bytes).then(function (buf) {
      var arr = Array.from(new Uint8Array(buf));
      return arr.map(function (b) {
        return b.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function autoSubmitLocksmithIfPending() {
    var pendingPw;
    try { pendingPw = sessionStorage.getItem(STORAGE_KEY); } catch (ex) { return; }
    if (!pendingPw) return;
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (ex) {}

    var hideStyle = document.createElement('style');
    hideStyle.id = 'vd-archive-hide-overlay';
    hideStyle.textContent = 'body{visibility:hidden!important;}';
    (document.head || document.documentElement).appendChild(hideStyle);

    var safetyTimer = setTimeout(function () {
      if (hideStyle.parentNode) hideStyle.remove();
    }, 3000);

    var attempts = 0;
    (function attempt() {
      attempts++;
      var lInput = document.getElementById('locksmith_passcode');
      var lSubmit = document.getElementById('locksmith_passcode_submit');
      if (lInput && lSubmit) {
        setTimeout(function () {
          lInput.value = pendingPw;
          lSubmit.click();
        }, 200);
        return;
      }
      if (attempts > 40) {
        clearTimeout(safetyTimer);
        if (hideStyle.parentNode) hideStyle.remove();
        return;
      }
      setTimeout(attempt, 100);
    })();
  }
})();